import { html, css } from 'lit'
import HHQuizElement from '../element.js'
import { repeat } from 'lit/directives/repeat.js'

/**
 * Selected products list
 * @extends
 */

class HHQuizSelectedProducts extends HHQuizElement {
  get addedToOrderVariantsIds() {
    return this.store.hydratedOrderLines.map((line) => line.variant.id)
  }

  /**
   * Renders list of selected products
   * @returns {TemplateResult}
   */
  render() {
    return html`
      ${repeat(
        this.store.selectedProductVariants,
        (variant) => variant.id,
        (variant) => html`<div class="hh-quiz-product-card">
            <hh-quiz-product-card
              .variant="${variant}"
              showDescription
              size="lg"
              >
              <div slot="actions" class="only-desktop">
                <hh-button
                  ?disabled="${!variant.available || this.addedToOrderVariantsIds.includes(variant.id)}"
                  @keydown="${(ev) => ev.stopPropagation()}"
                  @click="${() => this.store.addVariantToOrder(variant.id)}"
                >
                  ${!variant.available
                    ? HH_QUIZ.t.cart.out_of_stock
                    : this.addedToOrderVariantsIds.includes(variant.id)
                    ? HH_QUIZ.t.cart.added
                    : HH_QUIZ.t.cart.add}
                </hh-button>
              </div>
              <div slot="mobile-footer" class="hh-quiz-product-card__mobile-footer-actions only-mobile">
                <hh-button
                  ?disabled="${!variant.available || this.addedToOrderVariantsIds.includes(variant.id)}"
                  @keydown="${(ev) => ev.stopPropagation()}"
                  @click="${() => this.store.addVariantToOrder(variant.id)}"
                >
                  ${!variant.available
                    ? HH_QUIZ.t.cart.out_of_stock
                    : this.addedToOrderVariantsIds.includes(variant.id)
                    ? HH_QUIZ.t.cart.added
                    : HH_QUIZ.t.cart.add}
                </hh-button>
              </div>
            </hh-quiz-product-card>
          </div>
        </div>`
      )}
    `
  }

  static styles = [
    HHQuizElement.styles,
    css`
      .hh-quiz-product-card {
        padding: 40px 60px;
      }

      .hh-quiz-product-card__mobile-footer-actions {
        margin-top: 20px;
      }

      .hh-quiz-product-card:not(:last-child) {
        border-bottom: 1px solid var(--hh-color-grey-mineral);
      }

      @media screen and (max-width: ${HHQuizElement.mq.xs}px) {
        .hh-quiz-product-card {
          padding: 20px;
        }

        .hh-quiz-product-card:first-child {
          margin-top: 20px;
        }

        .hh-quiz-product-card:last-child {
          margin-bottom: 20px;
        }
      }
    `,
  ]
}

customElements.define('hh-quiz-selected-products', HHQuizSelectedProducts)
